<template>
  <div class="navbar marysmealsblue-navbar" id="navbar-wrapper">
    <ul class="nav-options my-3 text-center">
      <li v-for="(item, index) in menuItems" :key="index">
        <router-link
          :to="{ name: item.route }"
          class="nav-link"
          :class="{ active: router.currentRoute.value.name === item.route }"
          @click="setActiveMenu(item.id)"
        >
          <span v-html="item.icon" class="icon"></span>
          <span class="label">{{ item.label }}</span>
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, onUnmounted } from 'vue';
import { useRouter } from 'vue-router';
import {
  setActiveMenu as setActiveMenuService,
  updateMenuVisibility,
} from '@/services/utils/responsive.service';
import {
  removeStorageNavigation,
  syncNavigationStorageToStore,
} from '@/services/session/responsive-navigation-storage-sync.service';
import {useI18n} from 'vue-i18n';

const {t} = useI18n({useScope: 'global'});

const menuItems = [
  {
    id: 1,
    label: t('navigation.home'),
    route: 'Home',
    icon: `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="white" class="bi bi-house" viewBox="0 0 16 16">
  <path d="M8.707 1.5a1 1 0 0 0-1.414 0L.646 8.146a.5.5 0 0 0 .708.708L2 8.207V13.5A1.5 1.5 0 0 0 3.5 15h9a1.5 1.5 0 0 0 1.5-1.5V8.207l.646.647a.5.5 0 0 0 .708-.708L13 5.793V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.293zM13 7.207V13.5a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5V7.207l5-5z"/>
</svg>`,
  },
  { id: 2, label: t('navigation.fundraising'), route: 'Account Projects', icon: `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="white" class="bi bi-award" viewBox="0 0 16 16">
  <path d="M9.669.864 8 0 6.331.864l-1.858.282-.842 1.68-1.337 1.32L2.6 6l-.306 1.854 1.337 1.32.842 1.68 1.858.282L8 12l1.669-.864 1.858-.282.842-1.68 1.337-1.32L13.4 6l.306-1.854-1.337-1.32-.842-1.68zm1.196 1.193.684 1.365 1.086 1.072L12.387 6l.248 1.506-1.086 1.072-.684 1.365-1.51.229L8 10.874l-1.355-.702-1.51-.229-.684-1.365-1.086-1.072L3.614 6l-.25-1.506 1.087-1.072.684-1.365 1.51-.229L8 1.126l1.356.702z"/>
  <path d="M4 11.794V16l4-1 4 1v-4.206l-2.018.306L8 13.126 6.018 12.1z"/>
</svg>`},
  { id: 3, label: t('navigation.donations'), route: 'Account Transactions', icon: `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="white" class="bi bi-cash-stack" viewBox="0 0 16 16">
  <path d="M1 3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1zm7 8a2 2 0 1 0 0-4 2 2 0 0 0 0 4"/>
  <path d="M0 5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1zm3 0a2 2 0 0 1-2 2v4a2 2 0 0 1 2 2h10a2 2 0 0 1 2-2V7a2 2 0 0 1-2-2z"/>
</svg>`},
  { id: 4, label: t('navigation.settings'), route: 'Account Settings', icon: `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="white" class="bi bi-gear" viewBox="0 0 16 16">
  <path d="M8 4.754a3.246 3.246 0 1 0 0 6.492 3.246 3.246 0 0 0 0-6.492M5.754 8a2.246 2.246 0 1 1 4.492 0 2.246 2.246 0 0 1-4.492 0"/>
  <path d="M9.796 1.343c-.527-1.79-3.065-1.79-3.592 0l-.094.319a.873.873 0 0 1-1.255.52l-.292-.16c-1.64-.892-3.433.902-2.54 2.541l.159.292a.873.873 0 0 1-.52 1.255l-.319.094c-1.79.527-1.79 3.065 0 3.592l.319.094a.873.873 0 0 1 .52 1.255l-.16.292c-.892 1.64.901 3.434 2.541 2.54l.292-.159a.873.873 0 0 1 1.255.52l.094.319c.527 1.79 3.065 1.79 3.592 0l.094-.319a.873.873 0 0 1 1.255-.52l.292.16c1.64.893 3.434-.902 2.54-2.541l-.159-.292a.873.873 0 0 1 .52-1.255l.319-.094c1.79-.527 1.79-3.065 0-3.592l-.319-.094a.873.873 0 0 1-.52-1.255l.16-.292c.893-1.64-.902-3.433-2.541-2.54l-.292.159a.873.873 0 0 1-1.255-.52zm-2.633.283c.246-.835 1.428-.835 1.674 0l.094.319a1.873 1.873 0 0 0 2.693 1.115l.291-.16c.764-.415 1.6.42 1.184 1.185l-.159.292a1.873 1.873 0 0 0 1.116 2.692l.318.094c.835.246.835 1.428 0 1.674l-.319.094a1.873 1.873 0 0 0-1.115 2.693l.16.291c.415.764-.42 1.6-1.185 1.184l-.291-.159a1.873 1.873 0 0 0-2.693 1.116l-.094.318c-.246.835-1.428.835-1.674 0l-.094-.319a1.873 1.873 0 0 0-2.692-1.115l-.292.16c-.764.415-1.6-.42-1.184-1.185l.159-.291A1.873 1.873 0 0 0 1.945 8.93l-.319-.094c-.835-.246-.835-1.428 0-1.674l.319-.094A1.873 1.873 0 0 0 3.06 4.377l-.16-.292c-.415-.764.42-1.6 1.185-1.184l.292.159a1.873 1.873 0 0 0 2.692-1.115z"/>
</svg>` },
  { id: 5, label: t('navigation.logout'), route: 'Logout', icon: `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="white" class="bi bi-box-arrow-right" viewBox="0 0 16 16">
  <path fill-rule="evenodd" d="M10 12.5a.5.5 0 0 1-.5.5h-8a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 .5.5v2a.5.5 0 0 0 1 0v-2A1.5 1.5 0 0 0 9.5 2h-8A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h8a1.5 1.5 0 0 0 1.5-1.5v-2a.5.5 0 0 0-1 0z"/>
  <path fill-rule="evenodd" d="M15.854 8.354a.5.5 0 0 0 0-.708l-3-3a.5.5 0 0 0-.708.708L14.293 7.5H5.5a.5.5 0 0 0 0 1h8.793l-2.147 2.146a.5.5 0 0 0 .708.708z"/>
</svg>` },
];

const activeMenu = ref(1);
const router = useRouter();

const setActiveMenu = (id: number) => {
  activeMenu.value = id;
  setActiveMenuService(id);
};

onMounted(async () => {
  await syncNavigationStorageToStore();
  updateMenuVisibility();
  window.addEventListener('resize', updateMenuVisibility);
});

onUnmounted(async () => {
  window.removeEventListener('resize', updateMenuVisibility);
  await removeStorageNavigation();
});
</script>

<style>
body {
  margin: 0;
}

#navbar-wrapper {
  width: 100%;
  position: relative;
  top: 0;
  left: 0;
  /* z-index: 1000; */
  z-index: 0 !important; /* Doesn't interfere with the navbar from cms */
  color: white;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
}
.marysmealsblue-navbar {
  background-color: #007ba7;
}

.nav-options {
  flex-wrap: wrap !important;
  list-style-type: none !important;
  margin: 0;
  padding: 0 !important;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 2rem;
}

@media (max-width: 725px) {
  .nav-options {
    flex-direction: column;
    gap: 2rem;
 }

}

.nav-options li {
  align-content: center;
  margin: 0 12px !important;
}

.nav-link {
  color: white !important;
  text-decoration: none !important;
  padding: 18px 28px !important;
  display: flex;
  align-items: center;
  transition: background-color 0.3s ease !important;
}

.nav-link:hover,
.nav-link:focus,
.nav-link.active {
  background-color: #009ddc !important;
}

.icon {
  margin-right: 0.6rem !important; /* Slightly increased for spacing */
  color: white !important;
  width: 24px !important; /* Larger icon */
  height: 24px !important;
}

.label {
  color: white !important;
  font-size: 1.125rem !important;
}
</style>
